export * from './reset-password-page.component';
export * from './reset-password-page.module';
